/**
 * Frontend mirror of backend/src/doritostats/providers/policy.py.
 *
 * Yahoo's API agreement restricts how Yahoo league data may be stored,
 * displayed, and shared.  The backend enforces the rules; these helpers keep
 * the UI consistent (hide store-backed features, show the attribution line).
 */

export const YAHOO_ATTRIBUTION_TEXT = 'Fantasy data provided by Yahoo Fantasy';
export const YAHOO_ATTRIBUTION_URL = 'https://football.fantasysports.yahoo.com/';

const norm = (provider) => String(provider || '').trim().toLowerCase();

/** Providers whose data must carry an on-screen attribution. */
export const providerRequiresAttribution = (provider) => norm(provider) === 'yahoo';

/** Providers whose weekly stats may be kept in the historical store. */
export const providerPersistsHistory = (provider) => norm(provider) !== 'yahoo';

/** Providers whose data may be downloaded as a file. */
export const providerAllowsExport = (provider) => norm(provider) !== 'yahoo';

const LEAGUE_ROUTE_RE =
  /^\/fantasy_stats\/(?:league|simulation|league-history|league-cup|trade-hub|uh-oh-too-early\/[^/]+)\/([^/]+)\/[^/]+\/[^/]+/;

/** Extract the provider segment from a league-scoped pathname, or null. */
export const providerFromPathname = (pathname = '') => {
  const match = LEAGUE_ROUTE_RE.exec(pathname || '');
  return match ? norm(match[1]) : null;
};
